var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import { routeTo } from 'cf-util-route-handler';

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link(props, context) {
    _classCallCheck(this, Link);

    if (!props.to && !props.onClick) {
      throw new Error('<Link/> requires either a `to` or `onClick` prop');
    }

    var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.focus = _this.focus.bind(_this);
    return _this;
  }

  _createClass(Link, [{
    key: 'focus',
    value: function focus() {
      this.link.focus();
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      e.preventDefault();

      if (this.props.disabled) {
        return;
      }

      if (this.props.to) {
        routeTo(this.props.to);
      } else {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          tagName = _props.tagName,
          to = _props.to,
          children = _props.children,
          className = _props.className,
          disabled = _props.disabled,
          props = _objectWithoutProperties(_props, ['tagName', 'to', 'children', 'className', 'disabled']);

      if (!props.href && tagName === 'a') {
        props.href = to || '#!';
      }

      if (!props.role) {
        if (to && tagName !== 'a') {
          props.role = 'link';
        } else if (!to) {
          props.role = 'button';
        }
      }

      props.className = 'cf-link';

      if (disabled) {
        props.className += ' cf-link--disabled';
        props.disabled = true;
      }

      if (className) {
        props.className += ' ' + className;
      }

      props.onClick = this.handleClick;

      props.ref = function (node) {
        return _this2.link = node;
      };

      return React.createElement(tagName, props, children);
    }
  }]);

  return Link;
}(React.Component);

Link.propTypes = {
  to: PropTypes.string,
  onClick: PropTypes.func,
  tagName: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node
};

Link.defaultProps = {
  tagName: 'a'
};

export default Link;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-link/es/Link.js
// module id = 576
// module chunks = 0